export default __webpack_public_path__ + "static/orange-logo-text-683e0bc03870a7df2cdfad8322f06f72.svg";